"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const style = "normal";
const brand = "#5887A8"; // rgb( 88, 135, 168 )
const headerBackgroundColor = brand;
const headerTextColor = "#FFFFFF";
const mainInfoPortrait = headerTextColor;
const mainInfoLandscape = brand;
const fontFamily = `
@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-Regular.eot');
  src: url('/fonts/cerarob/CeraROB-Regular.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-Regular.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-Regular.ttf') format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-RegularItalic.eot');
  src: url('/fonts/cerarob/CeraROB-RegularItalic.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-RegularItalic.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-RegularItalic.ttf') format('truetype');
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-Medium.eot');
  src: url('/fonts/cerarob/CeraROB-Medium.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-Medium.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-Medium.ttf') format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-MediumItalic.eot');
  src: url('/fonts/cerarob/CeraROB-MediumItalic.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-MediumItalic.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-MediumItalic.ttf') format('truetype');
  font-weight: 600;
  font-style: italic;
}

@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-Bold.eot');
  src: url('/fonts/cerarob/CeraROB-Bold.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-Bold.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-Bold.ttf') format('truetype');
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: 'Cera Rob';
  src: url('/fonts/cerarob/CeraROB-BoldItalic.eot');
  src: url('/fonts/cerarob/CeraROB-BoldItalic.eot?#iefix') format('embedded-opentype'),
       url('/fonts/cerarob/CeraROB-BoldItalic.woff') format('woff'),
       url('/fonts/cerarob/CeraROB-BoldItalic.ttf') format('truetype');
  font-weight: 700;
  font-style: italic;
}

html {
    font-family: "Cera Rob", sans-serif ;
}

`;
exports.default = {
    headerTextColor,
    mainInfoLandscape,
    mainInfoPortrait,
    brand,
    headerBackgroundColor,
    fontFamily,
    style,
};
